<template>
  <div>
    <b-modal
      id="couponInvoice"
      v-model="isOpen"
      size="md"
      centered
      title="Conferência de Cupom"
      no-close-on-backdrop
      ok-only
      ok-title="Fechar"
      @ok="close"
    >
      <b-tabs content-class="mt-3">
        <b-tab title="Produtos Selecionados">
          <b-table
            :items="currentInvoice.invoice_data_user"
            :fields="fields"
            striped
            hover
          >
            <template #cell(total)="data">
              R$ {{ data.value }}
            </template>
            <template #custom-foot>
              <tr>
                <td><strong>Total:</strong></td>
                <td>
                  <strong>
                    R$ {{ calculateTotal(currentInvoice.invoice_data_user) }}
                  </strong>
                </td>
              </tr>
            </template>
          </b-table>
        </b-tab>
        <b-tab title="Produtos da Nota">
          <b-table
            :items="currentInvoice.invoice_data_api.produtos"
            :fields="fields"
            striped
            hover
          >
            <template #cell(total)="data">
              R$ {{ data.value }}
            </template>
            <template #custom-foot>
              <tr>
                <td><strong>Total:</strong></td>
                <td>
                  <strong>
                    R$ {{ calculateTotal(currentInvoice.invoice_data_api.produtos) }}
                  </strong>
                </td>
              </tr>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'CouponInvoiceDetail',
  components: {},
  props: {
    open: {
      type: Boolean,
      require: true,
    },
    currentInvoice: {
      type: Object,
    },
  },
  data() {
    return {
      isOpen: false,
      fields: [
        {
          key: 'nome',
          label: 'Nome do Produto',
        },
        {
          key: 'total',
          label: 'Valor Total',
        },
      ],
    }
  },
  watch: {
    open(value) {
      this.isOpen = value
    },
  },
  methods: {
    close() {
      this.isOpen = false
      this.$emit('close')
    },
    calculateTotal(items) {
      if (!items) return '0.00'
      const total = items.reduce((sum, item) => sum + parseFloat(item.total), 0)
      return total.toFixed(2)
    },
  },
}
</script>

<style scoped>
.text-bold {
  font-weight: bold;
}

.img-coupon {
  object-fit: contain;
  width: 100%;
  height: 500px;
}
</style>
